/**
 * @generated SignedSource<<220866b91d51b7e6a63652cdb346ba4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateGuideRelayFragment$data = {
  readonly name: string | null | undefined;
  readonly steps: ReadonlyArray<{
    readonly asset: {
      readonly url: string;
    } | null | undefined;
    readonly description: string | null | undefined;
    readonly name: string | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "templateGuideRelayFragment";
};
export type templateGuideRelayFragment$key = {
  readonly " $data"?: templateGuideRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateGuideRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateGuideRelayFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateUseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentPlatformTemplateImageAsset",
          "kind": "LinkedField",
          "name": "asset",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplateGuide",
  "abstractKey": null
};
})();

(node as any).hash = "8f191225e1f7fbeaa8da5aab976af219";

export default node;
